import { useAuth } from "../../../features/auth/use-auth.js";
import { useOffice } from "../../../features/office/use-office.js";
import { useTenant } from "../../../features/onboarding/tenant.context.js";
import type { SharedModalProps } from "./base-modal.jsx";
import { InviteModalEnterpriseVariant } from "./variants/invite-modal-enterprise-variant.jsx";
import { InviteModalRegularVariant } from "./variants/invite-modal-regular-variant.jsx";

export const InviteModal = (props: SharedModalProps) => {
  const { type: tenantType } = useTenant();
  const { channels, team } = useOffice();
  const { user } = useAuth();

  if (tenantType === "enterprise" && team) {
    return (
      <InviteModalEnterpriseVariant
        channelId={channels[0]?.msChannelId}
        teamId={team.msTeamId}
        tenantId={user.tenantId}
        title="Invite"
        {...props}
      />
    );
  }

  return <InviteModalRegularVariant {...props} />;
};
